import { Colors } from "../theme";

const LightCardStyle = {
    backgroundColor: `${Colors.lightBG}`,
    borderRadius: '15px',
    padding: '20px',
    width: '100%'
}

export default function LightCard({children, classNames}) {
    return (
        <div style={LightCardStyle} className={classNames}>
            {children}
        </div>
    );
}